// extracted by mini-css-extract-plugin
module.exports = {"gallery":"TraineeList_gallery__2lPg-","fade":"TraineeList_fade__3KN-7"};